import React, { useMemo } from "react"

import { AvailableModel, AvailableModelContext } from "@plugins/providers/model/AvailableModelContext"

import { useUserSession } from "@session/UserSession"

interface AvailableModelProviderProps {
    children: React.ReactNode
}
export function AvailableModelProvider({ children }: Readonly<AvailableModelProviderProps>) {
    const { client } = useUserSession()

    const search = useMemo(() => {
        return new AvailableModel(client)
    }, [client])

    return <AvailableModelContext.Provider value={search}>{children}</AvailableModelContext.Provider>
}
